function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.997 4.322c-.293-.302-.768-.302-1.061 0-.293.301-.293.79 0 1.092l3.22 3.314H3.966c-.38 0-.693.29-.743.667l-.007.105c0 .426.336.772.75.772h10.19l-3.22 3.314c-.266.275-.29.703-.073 1.006l.073.086c.293.302.768.302 1.06 0l4.5-4.632.064-.074c.022-.03.042-.061.06-.094l.022-.042.024-.057.012-.035c.007-.021.013-.044.019-.067l.007-.036c.008-.045.012-.093.012-.141l-.004.079c.002-.02.004-.04.004-.061V9.5v-.017c0-.02-.002-.041-.004-.062l-.008-.062-.007-.035c-.006-.025-.012-.048-.02-.072l-.01-.027c-.008-.022-.017-.044-.027-.065l-.02-.038c-.033-.061-.075-.118-.123-.168z"
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.8d5eab5f.svg";
export { ForwardRef as ReactComponent };